export default __webpack_public_path__ + "static/media/proxima_nova_semibold.a07b1727.ttf";